<template>
  <div>
    <div class="text-h4 mt-2 font-weight-light">
      {{ titulo }}
      <span class="text-subtitle-1">— {{ subtitulo }}</span>
    </div>

    <chartist
      :data="dados"
      :options="multipleBar.options"
      type="Bar"
      style="max-height: 150px;"
      class="mt-3"
    />
    <v-divider class="ma-3" />

    <div class="px-3">
      <div class="text-body-2 text-uppercase grey--text font-weight-bold mb-3">
        Legenda
      </div>

      <v-row
        align="center"
        class="ma-0"
      >
        <v-avatar
          class="mr-1"
          color="#00caef"
          size="12"
        />

        <span class="mr-3 font-weight-light">{{ serie1 }}</span>

        <v-avatar
          class="mr-1"
          color="#f44337"
          size="12"
        />

        <span class="mr-3 font-weight-light">{{ serie2 }}</span>
      </v-row>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'DashboardGraficoBarras',

    props: {
      titulo: {
        type: String,
        default: 'Titulo',
      },
      subtitulo: {
        type: String,
        default: 'Sub Titulo',
      },
      serie1: {
        type: String,
        default: 'serie 1',
      },
      serie2: {
        type: String,
        default: 'serie 2',
      },
      dados: {
        type: Object,
        default: function () {
          return {
            labels: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
            series: [
              [10, 15, 20, 25, 10, 15, 10, 15, 20, 25, 10, 15],
              [5, 10, 15, 20, 5, 10, 5, 10, 15, 20, 5, 10],
            ],
          }
        },
      },
    },
    data () {
      return {
        multipleBar: {
          options: {
            seriesBarDistance: 10,
            lineSmooth: this.$chartist.Interpolation.none(),
            axisX: {
              showGrid: true,
            },
            low: 0,
            // high: 900,
            chartPadding: {
              top: 0,
              right: 5,
              bottom: 0,
              left: 0,
            },
          },
          responsiveOptions: [
            ['screen and (max-width: 640px)', {
              seriesBarDistance: 10,
              axisX: {
                labelInterpolationFnc: function (value) {
                  return value[0]
                },
              },
            }],
          ],
        },
      }
    },

    computed: {

    },

    watch: {
      dados: function (val) {
        console.log('dados:', val)
        this.multipleBar.data.series = val
      },
    },

    mounted () {

    },
    methods: {

    },
  }
</script>

<style lang="sass">
  #multiple-bar
    .ct-series-a .ct-bar
      stroke: #00caef !important

    .ct-series-b .ct-bar
      stroke: #f44337 !important

</style>
